import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { TypeOf, object, string } from 'zod';

// Form component interface

export interface IChangePasswordFormProps {
  onSubmit: (newPassword: string, currentPassword: string) => void;
  apiError: FetchBaseQueryError | SerializedError | undefined;
  isLoading: boolean;
};

// Form fields

export const FIELDS = {
  CURRENT_PASSWORD: {
    FIELD: 'currentPassword',
    LABEL: 'Contraseña actual',
  },
  NEW_PASSWORD: {
    FIELD: 'newPassword',
    LABEL: 'Nueva contraseña',
  },
  CONFIRM_PASSWORD: {
    FIELD: 'confirmPassword',
    LABEL: 'Confirmación de contraseña',
  },
};

// Form validation schema

export const changePasswordFormSchema = object({
  [FIELDS.CURRENT_PASSWORD.FIELD]: string(),
  [FIELDS.NEW_PASSWORD.FIELD]: string(),
  [FIELDS.CONFIRM_PASSWORD.FIELD]: string(),
}).refine(({ newPassword, confirmPassword }) => Boolean(newPassword === confirmPassword),
{
  message: "Las contraseñas deben coincidir",
  path:["confirmPassword"]
});

// Form values interface

export type IChangePasswordForm = TypeOf<typeof changePasswordFormSchema>;

// Translations

